const mEditionAccountProfile = {
  mEditionAccountProfile: {
    alerts: {
      updateUsuario: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los datos de perfil fueron actualizados exitosamente.'
      }
    },

    inputs: {
      cod_postal: {
        label: 'Código Postal',
        placeholder: 'código postal'
      },

      documento_tipo: {
        label: 'Tipo de Documento'
      },

      documento_numero: {
        label: 'Número de Documento',
        message: '* De 3 a 30 caracteres'
      },

      fisica: {
        label: 'Tipo de Persona'
      },

      localidad: {
        label: 'Localidad',
        placeholder: 'localidad'
      },

      linea1: {
        label: 'Dirección Principal',
        placeholder: 'Mi Dirección'
      },

      linea2: {
        label: 'Dirección Opcional'
      },

      movil: {
        label: 'Número de Móvil'
      },

      pais: {
        label: 'País'
      },

      provincia: {
        label: 'Provincia'
      },

      razon_social: {
        labelBusiness: 'Razón Social',
        labelName: 'Nombre',
        message: '* De 3 a 150 caracteres',
        placeholder: 'Mi nombre'
      },

      telefono: {
        label: 'Número de Teléfono'
      }
    },

    validation: {
      documento_numero: {
        maxLength: 'La longitud máxima permitida es de 30 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Número de Documento es requerido. De 3 a 30 caracteres.'
      },

      fisica: {
        required: 'Tipo de Persona es requerido.'
      },

      movil: {
        required: 'Número de Móvil es requerido.'
      },

      razon_social: {
        maxLength: 'La longitud máxima permitida es de 150 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Dato requerido. De 3 a 150 caracteres.'
      },

      pais: {
        required: 'País es requerido.'
      },

      provincia: {
        required: 'Provincia es requerida.'
      },

      documento_tipo: {
        required: 'Tipo de Documento es requerido.'
      },

      telefono: {
        required: 'Número de Teléfono es requerido.'
      }
    }
  }
}

export default mEditionAccountProfile
